import UserProfile from './container';

export default UserProfile;



// WEBPACK FOOTER //
// ./src/routes/UserProfile/index.js